export default __webpack_public_path__ + "static/tecalis-students_07-60d3a650bfa3d5f03683f8f6e61fe2c5.png";